import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { authClient } from "../context/auth";

export const Route = createFileRoute("/_auth")({
  beforeLoad: async ({ location }) => {
    const session = await authClient.getSession();

    if (!session?.data?.user) {
      throw redirect({
        to: "/login",
        search: { redirect: location.href },
      });
    }

    return { user: session.data.user };
  },
  component: () => <Outlet />,
});
